export default __webpack_public_path__ + "static/media/Enkoping.0774cba5.svg";